import React from 'react'
import {
  Datagrid,
  List,
  TextField,
  EditButton,
  SelectField,
  TopToolbar,
  DeleteWithConfirmButton,
  SearchInput,
} from 'react-admin'
import { Button } from '@material-ui/core'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import ChatIcon from '@material-ui/icons/Chat'
import CustomPagination from '../../MyPagination'
import ExportModal from '../../components/ExportModal'
import ContactModal from '../../components/ContactModal'

const ClubsList = (props) => {
  const [modalType, setModalType] = React.useState(null)
  const handleOpenClubModal = () => setModalType('club')
  const handleCloseClubModal = () => setModalType(null)

  const [contactModalOpened, setContactModalOpened] = React.useState(false)
  const handleOpenContactModal = () => setContactModalOpened(true)
  const handleCloseContactModal = () => setContactModalOpened(false)

  const ClubsListActions = ({ basePath, data, resource }) => (
    <TopToolbar>
      {/* Add your custom actions */}
      <Button startIcon={<ChatIcon />} color="primary" onClick={handleOpenContactModal}>
        Écrire à tous les clubs
      </Button>
      <Button startIcon={<CloudDownloadIcon />} color="primary" onClick={() => handleOpenClubModal()}>
        Exporter les clubs
      </Button>
    </TopToolbar>
  )

  const postFilters = [<SearchInput source="qName" alwaysOn />]

  return (
    <div>
      <List
        {...props}
        filters={postFilters}
        pagination={<CustomPagination />}
        bulkActionButtons={false}
        actions={<ClubsListActions />}
        sort={{ field: 'name', order: 'DESC' }}
      >
        <Datagrid>
          <TextField source="code" label="Code" />
          <TextField source="name" label="Nom" />
          <TextField source="league" label="Ligue" />
          <TextField source="committee" label="Nom du comité" sortable={false} />
          <SelectField
            source="status"
            label="Statut demande d'inscription"
            choices={[
              { id: 'hidden', name: 'Refusé' },
              { id: 'displayed', name: 'Accepté' },
              { id: 'pending', name: 'En attente' },
            ]}
          />
          <EditButton label="Éditer le club" basePath="/clubs" />
          <DeleteWithConfirmButton
            label="Supprimer le club"
            confirmContent="Êtes-vous sûr de vouloir supprimer ce club ? Les données seront définitivement perdues."
          />
        </Datagrid>
      </List>
      <ExportModal handleClose={handleCloseClubModal} type={modalType} />
      <ContactModal handleClose={handleCloseContactModal} open={contactModalOpened} receiver="CLUBS" />
    </div>
  )
}
export default ClubsList
